/* Bold Grip Socks — remove stale pre-order notes from cart lines.
   The cart templates mark a line with data-bm-stale-po="<line key>" when it still carries a
   "Pre-order" (or old "_backorder") property but none of its colours is on pre-order any more
   (stock is back). This drops that property so it never reaches checkout. Other properties
   (Colors, etc.) are kept. Pre-order lines for colours that are still on pre-order are untouched. */
(function () {
  var STALE_KEYS = ['Pre-order', '_backorder'];

  function staleKeys() {
    var out = {};
    document.querySelectorAll('[data-bm-stale-po]').forEach(function (el) {
      var k = el.getAttribute('data-bm-stale-po');
      if (k) out[k] = true;
    });
    return out;
  }

  function cleanProps(props) {
    var keep = {}, changed = false;
    Object.keys(props || {}).forEach(function (k) {
      if (STALE_KEYS.indexOf(k) !== -1) { changed = true; return; }
      keep[k] = props[k];
    });
    return changed ? keep : null;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r; });
  }

  // Shopify ignores an empty properties object, so a line whose only property was the
  // pre-order note is added back without it and the old line is then removed.
  function fixLine(it) {
    var keep = cleanProps(it.properties);
    if (Object.keys(keep).length) {
      return post('/cart/change.js', { id: it.key, quantity: it.quantity, properties: keep });
    }
    var add = { id: it.variant_id, quantity: it.quantity };
    if (it.selling_plan_allocation) add.selling_plan = it.selling_plan_allocation.selling_plan.id;
    return post('/cart/add.js', { items: [add] }).then(function () {
      return post('/cart/change.js', { id: it.key, quantity: 0 });
    });
  }

  function refreshDrawer() {
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = /^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?cart\/?$/.test(location.pathname);
    if (onCartPage) { location.reload(); return; }
    if (!drawer) return;
    fetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var doc = new DOMParser().parseFromString(s['cart-drawer'] || '', 'text/html');
        var fresh = doc.querySelector('#CartDrawer');
        var cur = document.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function run() {
    var keys = staleKeys();
    if (!Object.keys(keys).length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var jobs = (cart.items || []).filter(function (it) { return keys[it.key] && cleanProps(it.properties); });
        if (!jobs.length) return;
        var chain = Promise.resolve();
        jobs.forEach(function (it) {
          chain = chain.then(function () { return fixLine(it).catch(function () {}); });
        });
        return chain.then(refreshDrawer);
      })
      .catch(function () {});
  }

  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
